export enum RatePlanExtraInfoType {
  NoSmoking = 1,
  Smoking = 2,
  WithWindow = 3,
  NoWindow = 4,
  NoCleaningService = 5,

}
